export default () => ({
  darkMode: null,
  language: null,
});
